import React from 'react';

import Framework from "@beardeddevops/react.framework";
import ManagerCharts from "../../../../../components/Containers/ManagerCharts";
import Tickers from "../../../../../components/Parts/Tickers";

const breadcrumbStatic = [{
	name: 'Managers',
	url: '/managers',
	icon: 'dashboard'
}];

class ManagerChartsContainer extends Framework.Components.View {
	constructor(props) {
		super(props);
		this.state = {
			key: Math.random()
		}
	}

	render() {
		let {history} = this.props;
		return(
			<div style={{position: 'relative', paddingLeft: 20, paddingRight: 20}}>
				{/*<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}/>*/}

				<ManagerCharts history={history} triggerReload={async () => {
					await this.props.rootState.triggerAction('getUserInformation', {fromRouteChange: false, forceTrigger: true}).then(() => {
						this.setState({key: Math.random()})
					});
				}} />
				<div style={{display: 'flex', flexDirection: 'column'}} key={this.state.key}>
					<Tickers.HiringTicker/>
					<Tickers.HelpdeskTicker/>
					<Tickers.DispatchTicker/>
				</div>
			</div>
		)
	}
}

export default Framework.Components.withRootState(ManagerChartsContainer);